module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAAb1BMVEUAAABnZ2dmZmZmZmZtdnlmZmZmZmYAtOsAseYAr+VmZmYKqtsAseZnZ2cAs+gAsOUAsOVnZ2cKrN5paWlra2sAsOUAsOUAsOUAseVFf5BoaGgAr+RdbHEUoctUc3wLp9cjlrksj65Df5IdmsAzi6UyndnLAAAAG3RSTlMAevDiDNS9ETzUrJdrZSbDr5RQPhvz57hYw0w62cEfAAAAwklEQVQoz23QxxKDMAxF0Ucgtum9JKKE8v/fGJsAIzK+Cy90FtYInnD/EtBVDuIctoQDx7FBHsAu8dOzS+lWsErlluCiwtRvIwl4zxhMZEh7dYQgBxPp09lLgEt2wWcsuKgLhn7woQsOCcfpB1O/EiVmi0Pa+aBx00/BJKW5H/RsWQx3TDL9s6Z5JJNi0pGhrZ8M1GAiGz1Zl4FMIRcUdOXLmyA6IU1wFyT7GZoIYHIklUqAm7C4xIFN3kKreFhyS3wBxtcTeZ60H7EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/download-select@2x.png
// module id = YBIr
// module chunks = 4